import React, { useMemo } from 'react';

import { getNewbuildingMediaLabels } from './utils';
import { GalleryLabels } from '../../../../components/GalleryLabels';
import { useOfferContext } from '../../../../context';

export function OfferLabelsContainer() {
  const { hasVideo, hasTour, mediaLabels, isNewbuildingFromDeveloper, isNewbuildingFromBuilder } = useOfferContext();

  const displayLabels = useMemo(
    () => (isNewbuildingFromDeveloper ? getNewbuildingMediaLabels(isNewbuildingFromBuilder) : mediaLabels),
    [isNewbuildingFromBuilder, isNewbuildingFromDeveloper, mediaLabels],
  );

  if (!displayLabels.length) {
    return null;
  }

  return <GalleryLabels hasFeatures={hasVideo || hasTour} labels={displayLabels} />;
}
